import { ThemeOptions } from '@mui/material';

export const MuiFormControlLabel: ThemeOptions['components']['MuiFormControlLabel'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&:has(.MuiRadio-root)': {
        marginRight: theme.spacing(3),
        alignItems: 'flex-start',
        '&.Mui-disabled': {
          '.MuiTypography-root': {
            color: theme.palette.text.secondary
          }
        }
      },
      // Styles for Radio button options item description
      '& .cds-radioButtonDescription': {
        marginBottom: theme.spacing(1),
        color: theme.palette.text.disabled
      }
    })
  }
};
